import createReducer from "utils/createReducer";
import { fromJS } from "immutable";
import { logError } from "utils/logError";
import {
  CategoryTypes,
  ServerSentEventTypes,
  JackpotTypes,
} from "actions/types";

//export const defaultValue = fromJS({})
export const defaultValue = fromJS({});

export const games = createReducer(defaultValue, {
  [CategoryTypes.CLEAR_GAMES](state, { payload }) {
    // A list unmounting before its link resolved clears nothing.
    if (!payload) return state;
    try {
      return state.delete(payload.get("rel"));
    } catch (err) {
      logError("games reducer: CLEAR_GAMES", err);
      return state;
    }
  },
  [CategoryTypes.FETCH_GAMES](state, { payload }) {
    let newState = state;
    let initialPage =
      !payload.get("params") ||
      !payload.getIn(["params"]).get("page") ||
      payload.getIn(["params"]).get("page") === "1";
    if (initialPage) {
      newState = newState.setIn(
        [payload.getIn(["route", "rel"]), "data"],
        null
      );
      newState = newState.setIn(
        [payload.getIn(["route", "rel"]), "isLoading"],
        true
      );
    } else {
      newState = newState.setIn(
        [payload.getIn(["route", "rel"]), "isLoading"],
        false
      );
      newState = newState.setIn(
        [payload.getIn(["route", "rel"]), "isLoadingNext"],
        true
      );
    }
    return newState;
  },
  [CategoryTypes.SET_GAMES](state, { payload }) {
    let newState = state;
    if (payload.getIn(["data", "page"]) > 1) {
      let mergedPayload = payload.setIn(
        ["data", "items"],
        newState
          .getIn([payload.getIn(["route", "rel"]), "data", "items"])
          .concat(payload.getIn(["data", "items"]))
      );
      newState = newState.mergeIn(
        [payload.getIn(["route", "rel"])],
        mergedPayload
      );
    } else {
      newState = newState.mergeIn([payload.getIn(["route", "rel"])], payload);
    }
    newState = newState.setIn(
      [payload.getIn(["route", "rel"]), "isLoading"],
      false
    );
    newState = newState.setIn(
      [payload.getIn(["route", "rel"]), "isLoadingNext"],
      false
    );

    return newState;
  },
  [CategoryTypes.SHOW_SEE_ALL_CATEGORY](state, { payload }) {
    let newState = state.setIn([payload, "seeAll"], true);
    return newState;
  },
  [CategoryTypes.HIDE_SEE_ALL_CATEGORY](state, { payload }) {
    let newState = state.setIn([payload, "seeAll"], false);
    return newState;
  },
  [ServerSentEventTypes.MESSAGE_SERVER_SENT_EVENT](state, { payload }) {
    //state.getIn(['jackpots', 'data', 'items']).toJSON()

    if (payload.type !== "jp-pool-balance-update") return state;

    let newState = state;

    try {
      newState.forEach((games, key) => {
        let gameKey = key;
        let jackpotKey;
        let poolKey;
        let sortedPool;
        let newPool;

        // Categories that are still loading, or don't hold this jackpot, have no pools to update.
        const items = games.getIn(["data", "items"]);
        jackpotKey = items?.findKey((item) => {
          return item.get("id") === payload.message.jackpotGroupId;
        });
        const pools = items?.getIn([jackpotKey, "jpPools"]);
        if (!pools) return;
        poolKey = pools.findKey((pool) => {
          return pool.get("type") === payload.message.type;
        });

        newPool = {
          type: payload.message.type,
          amount: payload.message.amount,
        };

        if (gameKey !== null && jackpotKey !== null) {
          if (poolKey > -1) {
            newState = newState.setIn(
              [gameKey, "data", "items", jackpotKey, "jpPools", poolKey],
              fromJS(newPool)
            );
          } else {
            newState = newState.setIn(
              [gameKey, "data", "items", jackpotKey, "jpPools"],
              newState
                .getIn([gameKey, "data", "items", jackpotKey, "jpPools"])
                .push(fromJS(newPool))
            );
          }

          sortedPool = newState
            .getIn([gameKey, "data", "items", jackpotKey, "jpPools"])
            .sort((a, b) => Number(b.get("amount")) - Number(a.get("amount")));
          let totalJackpot = 0;
          sortedPool.map((pool) => {
            return (totalJackpot += Number(pool.get("amount")));
          });
          newState = newState.setIn(
            [gameKey, "data", "items", jackpotKey, "balance"],
            totalJackpot
          );
        }
      });
    } catch (err) {
      logError("games reducer: apply jp-pool-balance-update", err);
    }

    return newState;
  },
  [JackpotTypes.SET_JACKPOT_DETAILS](state, { payload }) {
    let newState = state;

    if (!payload.data) return state;

    // A jackpot opened before the lobby's jackpot list loaded has no list to look up (null key).
    const items = newState.getIn(["jackpots", "data", "items"]);
    const jackpotKey = items
      ? items.findKey((item) => {
          return item.get("id") === payload.data.id;
        })
      : null;

    let oldLinks = newState.getIn([
      "jackpots",
      "data",
      "items",
      jackpotKey,
      "links",
    ]);
    let newLinks = fromJS(payload.data.links);
    if (oldLinks && newLinks) {
      payload.data.links = newLinks.toSet().union(oldLinks.toSet()).toList();
    }

    // FETCH_GAMES nulls the list's data while it reloads: there is nothing to write into yet.
    if (newState.getIn(["jackpots", "data"]) === null) return state;

    try {
      newState = newState.setIn(
        ["jackpots", "data", "items", jackpotKey],
        fromJS(payload.data)
      );
    } catch (err) {
      logError("games reducer: SET_JACKPOT_DETAILS write", err);
      return state;
    }

    let jpPools = newState.getIn([
      "jackpots",
      "data",
      "items",
      jackpotKey,
      "jpPools",
    ]);
    if (jpPools) {
      let sortedPool = jpPools.sort(
        (a, b) => Number(b.get("amount")) - Number(a.get("amount"))
      );
      let totalJackpot = 0;
      sortedPool.map((pool) => {
        return (totalJackpot += Number(pool.get("amount")));
      });
      newState = newState.setIn(
        ["jackpots", "data", "items", jackpotKey, "highestJpPoolAmount"],
        totalJackpot
      );
    }

    return newState;
  },
});
